export const env = { ...process.env, ...window.env };

export function checkFeature(feature) {
  return env.REACT_APP_FEATURES?.split(',').find((f) => f === feature) ?? false;
}
